import firebase from '@/config/firebase'
import globals from '@/config/globals'
import { firestoreAction } from 'vuexfire'

const getDefaultState = () => ({
  collection: {},
  status: {
    value: false,
    data: null
  }
})

const tickets = {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    setCollection(state, data) {
      state.collection = data
    },

    setStatus(state, data) {
      state.status = data
    },

    reset(state) {
      Object.assign(state, getDefaultState())
      state.status = { value: false, data: 'Data wiped.' }
    }
  },

  actions: {
    loadCollection: firestoreAction(({ bindFirestoreRef, commit, rootGetters }) => {
      let query = false
      let response = null

      if (rootGetters['account/type'] === 'admin') {
        query = firebase.firestore().collection(globals.firebase.collection.tickets)
      }

      if (query) {
        response = bindFirestoreRef('collection', query)
          .then(() => {
            commit('setStatus', { value: true, data: 'Collection bound.' })
            console.info('Tickets collection bound.')
          })
          .catch((error) => {
            commit('setStatus', { value: false, data: error.stack.toString() })
            console.error('Error binding collection (tickets):', error)
          })
      }

      return response
    }),

    reset: firestoreAction(({ commit, unbindFirestoreRef }) => {
      commit('reset')
      unbindFirestoreRef('collection')
    })
  },

  getters: {
    find: (state) => (id) => state.collection.find((ticket) => ticket.id === id) || null
  }
}

export default tickets
